<template>
  <div class="school-orders">
    <v-row>
      <v-col cols="12" md="3">
        <SchoolNavigation />
      </v-col>
      <v-col cols="12" md="9">
        <div class="d-flex flex-wrap align-center">
          <h3 class="flex-fill">گزارش کد تخفیف</h3>
          <v-btn depressed color="success" :disabled="loading">
            <download-csv
              :data="codes"
              name="گزارش کد تخفیف.csv"
              :labels="csvlabels"
              :fields="csvfields"
              class="d-flex align-center"
            >
              <v-icon class="ml-2 text-body-2"
                >mdi-content-save-settings-outline</v-icon
              >
              <small>ذخیره گزارش</small>
            </download-csv>
          </v-btn>
        </div>
        <v-data-table
          dense
          :items="codes"
          :headers="headers"
          :items-per-page="10"
          :loading="loading"
          loading-text="در حال ساخت گزارش ..."
          class="mt-5 px-3 text-no-wrap"
        >
          <template v-slot:[`item.used`]="{ item }">
            <span v-if="item.used">بله</span>
            <span v-else>خیر</span>
          </template>
        </v-data-table>
        <div class="text-center">
          <v-btn
            text
            depressed
            class="mt-5"
            router
            :to="{ name: 'SchoolOrders' }"
          >
            بازگشت
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SchoolNavigation from "./SchoolNavigation.vue";
export default {
  name: "discount-report-component",
  components: {
    SchoolNavigation
  },
  data: () => {
    return {
      loading: false,
      headers: [
        { text: "کد تخفیف", align: "center", value: "code" },
        { text: "درصد تخفیف", align: "center", value: "percent" },
        { text: "استفاده شده؟", align: "center", value: "used" },
        { text: "استفادکننده", align: "center", value: "user" },
        { text: "نام کتاب", align: "center", value: "book" },
        { text: "پایه", align: "center", value: "grade" },
        {
          text: "تعداد شرکت در آزمون",
          align: "center",
          value: "answerSheetCount"
        },
        {
          text: "نمره پایانی (%)",
          align: "center",
          value: "totalScore"
        },
        { text: "تمرکز (%)", align: "center", value: "focusScore" },
        {
          text: "استنباط (%)",
          align: "center",
          value: "inferenceScore"
        },
        {
          text: "تفسیر (%)",
          align: "center",
          value: "interpretationScore"
        },
        {
          text: "ارزیابی (%)",
          align: "center",
          value: "assessmentScore"
        }
      ],
      codes: [],
      csvfields: [
        "code",
        "used",
        "user",
        "book",
        "grade",
        "answerSheetCount",
        "totalScore",
        "focusScore",
        "inferenceScore",
        "interpretationScore",
        "assessmentScore"
      ],
      csvlabels: {
        code: "کد تخفیف",
        used: "استفاده شده؟",
        user: "نام و نام خانوادگی",
        book: "نام کتاب",
        grade: "پایه",
        answerSheetCount: "تعداد شرکت در آزمون",
        totalScore: "نمره پایانی (%)",
        focusScore: "تمرکز (%)",
        inferenceScore: "استنباط (%)",
        interpretationScore: "تفسیر (%)",
        assessmentScore: "ارزیابی (%)"
      }
    };
  },
  created() {
    this.handleGetDiscountCodes();
  },
  methods: {
    handleGetDiscountCodes() {
      this.loading = true;
      this.$api
        .get("/schoolResaultByBatch/" + this.$route.params.id)
        .then((res) => {
          this.codes = res.data.discountCodes;
          this.loading = false;
        });
    }
  }
};
</script>
